package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_paymentlink_data_di_PaymentLinkModule : Module get() = module {
	single() { _ -> com.essntl.features.paymentlink.data.repository.PaymentLinkRepositoryImpl(supabase=get()) } bind(com.essntl.features.paymentlink.domain.repository.PaymentLinkRepository::class)
	single() { _ -> com.essntl.features.paymentlink.data.supabase.PaymentLinkSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.paymentlink.data.supabase.PaymentLinkSupabaseDataSource::class)
}
public val com.essntl.features.paymentlink.data.di.PaymentLinkModule.module : org.koin.core.module.Module get() = com_essntl_features_paymentlink_data_di_PaymentLinkModule
